import { useEffect, useState, useRef } from 'react';

import { Table, Container, Button, Form } from 'react-bootstrap';
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import { green } from '@material-ui/core/colors'
import SaveIcon from '@material-ui/icons/Save'
import Tooltip from '@material-ui/core/Tooltip'
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined'
import MuiAlert from '@material-ui/lab/Alert'

import './styles.css';

import { createHostScript, listHostScripts, deleteHostScript, } from '../../services/api';

import ToastAnimated, { showToast } from '../../ui-lib/toast';
import 'react-toastify/dist/ReactToastify.css';

import NavBar from '../../components/NavBar/NavBar';
import CorpoCadScript from '../../components/CorpoEmpresas/scriptsShow';


const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -10,
  },
  customWidth: {
    maxWidth: 500,
  },
}));


function Alert(props) {
  return <MuiAlert elevation={3} variant="filled" {...props} />
}


function ShowScript() {
  const companyId = localStorage.getItem('idEmpresa');
  const idHost = localStorage.getItem('idHost');
  const hostName = localStorage.getItem('name_host');
  const companyName = localStorage.getItem('name_empresa');

  const classes = useStyles()
  const timer = useRef()
  const [scripts, setScripts] = useState([]);
  const [statusSalvar, setStatusSalvar] = useState('Salvar');
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [buttonClassname, setButtonClassname] = useState('dark');


  function getScripts() {
    listHostScripts(idHost).then(({ data, }) => setScripts(data));
  }

  useEffect(() => {
    getScripts();
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    }
  }, []);

  const handleButtonClick = () => {
    if (!loading) {
      createHostScript(idHost, name)
        .then(() => {
          setButtonClassname('warning')
          setLoading(true)
          setStatusSalvar('Salvando')
          timer.current = window.setTimeout(() => {
            setButtonClassname('success')
            setLoading(false)
            setStatusSalvar('Salvo')
            getScripts();
          }, 2000)
        })
        .catch(({ data }) => {
          console.log(data)
          return showToast({
            type: 'error',
            message: 'Erro ao criar script',
          })
        })
    }
  }

  /**
   * @param {string} scriptId
   */
  async function onDeleteScript(scriptId) {
    try {
      await deleteHostScript(companyId, idHost, scriptId);
      setScripts(scripts.filter((s) => s._id != scriptId));
      showToast({
        type: 'success',
        message: 'Script excluído com sucesso',
      });
    } catch (error) {
      return showToast({
        type: 'error',
        message: 'Erro ao excluir script',
      });
    }
  }


  return (
    <NavBar >
      <TableContainer
        component={Paper}
        elevation={8}
      >
        <Alert
          color="warning"
          severity="error"
          icon={<AddCircleOutlinedIcon fontSize="inherit" />}
          style={{
            width: '50%',
            margin: '1rem auto',
          }}
        >
          Cadastrar um script no {hostName} da empresa {companyName}
        </Alert>

        <Container
          style={{
            marginBottom: '1rem',
          }}
        >
          <Table
            striped
            bordered
            hover
            size="sm"
          >
            <thead>
              <tr>
                <th></th>
                <th>Script</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <div className={classes.wrapper}>
                  <ToastAnimated />
                  <Button
                    variant={buttonClassname}
                    disabled={loading}
                    onClick={handleButtonClick}
                  >
                    <SaveIcon /> {statusSalvar}
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
                <td>
                  <Tooltip
                    title={name}
                    classes={{ tooltip: classes.customWidth }}
                  >
                    <Form.Control
                      type="email"
                      value={name}
                      onChange={(event) => {
                        setName(event.target.value)
                      }}
                    />
                  </Tooltip>
                </td>
              </tr>
            </tbody>
          </Table>
        </Container>

        <Container>
          <Table
            striped
            bordered
            hover
          >
            <thead>
              <tr>
                <th>Grupo de verificação</th>
                <th>Nome dos scripts</th>
                <th>Data da criação</th>
                <th>TOKEN</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {
                scripts.map((script) => {
                  return (
                    <CorpoCadScript
                      key={script._id}
                      data={script}
                      onDelete={onDeleteScript}
                    />
                  );
                })
              }
            </tbody>
          </Table>
        </Container>
      </TableContainer>
    </NavBar>
  )
}

export default ShowScript;
